import React from 'react';
import PropTypes from 'prop-types';
import styles from './sidebar.scss';

const Sidebar = (props) => {
    const { isCloseable = true, showClose = true, onClose, children, 'data-testid': dataTestId } = props;

    return (
        <div className={styles.sidebarWrapper} data-testid={dataTestId}>
            <div className={styles.sidebarOverlay} onClick={() => isCloseable && onClose()} data-testid={dataTestId ? `${dataTestId}.overlay` : undefined} />
            <div className={styles.sidebarContainer}>
                {isCloseable && showClose && (
                    <div className={styles.sidebarClose} onClick={() => onClose()} data-testid={dataTestId ? `${dataTestId}.close-btn` : undefined}>
                        <i className="utr utr-close" />
                    </div>
                  )}
                {children}
            </div>
        </div>
    );
};

Sidebar.propTypes = {
    isCloseable: PropTypes.bool,
    showClose: PropTypes.bool,
    onClose: PropTypes.func,
    children: PropTypes.node,
};

Sidebar.defaultProps = {
    isCloseable: true,
    showClose: true,
    onClose: () => { },
    children: null,
};

export default Sidebar;
